/**
 * @generated SignedSource<<96eec3787d36786d8ce25fcc3d80f4a9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BuySharedMoreWaysToBrowse_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SharedMobileLinksBlock_viewer" | "SharedRespLinksBlock_viewer">;
  readonly " $fragmentType": "BuySharedMoreWaysToBrowse_viewer";
};
export type BuySharedMoreWaysToBrowse_viewer$key = {
  readonly " $data"?: BuySharedMoreWaysToBrowse_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"BuySharedMoreWaysToBrowse_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuySharedMoreWaysToBrowse_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedMobileLinksBlock_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedRespLinksBlock_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "0792555adee289bae2d476c15054c8db";

export default node;
